<div style="font-size: 16px; font-weight: 500;">
  {{title}}
  <mat-divider [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
</div>

<div *ngIf="inspectionFiles?.length > 0 else showNoFilesToDisplay">
  <mat-list class="file-list"
    [ngStyle]="{'width': '90%'}"
    ngStyle.lt-lg="{'width': '100%'}"
    ngStyle.lt-md="{'margin-top': '28px', 'margin-bottom': '28x'}">
    <mat-list-item
      *ngFor="let file of inspectionFiles">
      <div matLine
        style="display: inline-block !important; width: 100%;"
        ngStyle.gt-sm="{'margin-bottom': '12px'}"
        ngStyle.lt-md="{'margin-bottom': '36px'}">

        <div fxLayout="row" fxLayout.lt-md="column wrap"
          ngStyle.gt-sm="{'margin-top': '9px'}">
          <div fxFlex='80%'>
            <div style="float: left !important;">
              <div style="font-size: 14px; font-weight: 400;">
                {{file.fileTypeOptionSet}}
              </div>
              <a style="color: #29637C; font-size: 16px; font-weight: 400;" [title]="file.name"
                href="javascript:void(0)" (click)="onViewFileEvent(file.id)">
                {{file.name | Filename}}
              </a>
            </div>
          </div>

          <div fxFlex='20%'>
            <button mat-stroked-button color="primary"
              style="text-transform: uppercase;"
              ngStyle.gt-sm="{'margin-top': '6px'}"
              (click)="onUploadFileEvent(file.id)"
              [disabled]="this.submittedInspection">
              REPLACE
          </button>
          </div>
        </div>
      </div>
      <mat-divider fxShow ></mat-divider>

    </mat-list-item>
  </mat-list>
</div>
<ng-template #showNoFilesToDisplay>
  <p style="margin-top: 6px; font-size: 14px;">
    No files found.
  </p>
</ng-template>
<div style="margin-top: 12px;">
  <button mat-stroked-button color="primary"
    style="text-transform: uppercase;"
    (click)="onUploadFileEvent(null)"
    [disabled]="this.submittedInspection">
    Upload a file
  </button>
</div>

<div *ngIf="formProgressSave" style="margin-top: 12px;">
  <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
</div>
